<script type="text/babel">
export default {
  name: 'BaseTabInterface',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    initialTab: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTab: '',
    }
  },
  watch: {
    initialTab() {
      this.changeActiveTab(this.initialTab.slug)
    },
  },
  async mounted() {
    await this.$nextTick()

    this.activeTab = this.initialTab.slug

    const windowLocationHash = window.location.hash.substring(1)

    if (windowLocationHash) {
      this.changeActiveTab(windowLocationHash)
    }
  },
  methods: {
    changeActiveTab(tab) {
      this.activeTab = tab

      history.pushState(null, null, `#${tab.toLowerCase()}`)

      //scroll to top of the page only on desktop
      if(window.innerWidth > 768 ) {
        window.scrollTo(0, 0)
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      activeTab: this.activeTab,
      tabs: this.tabs,
      changeActiveTab: this.changeActiveTab,
    })
  },
}
</script>
